import request from '@/utils/request';

import { ResCode, PagingReq, User, CommonResponse } from './baseDefine';
export interface Schedule{
    id: number;
    meterID: string;
    powerPlantId: string;
    file: string;
    name: string;
    type: string;
    version: number;
    interval: number;
    count: number;
}
export interface GetSchedule{
    code: ResCode;
    msg: string;
    data : Schedule;
}
export function createSchedule(req: Schedule): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/scheduel/createScheduel', req);
}
export function getSchedule(req: Schedule): Promise<GetSchedule> {
    return request.post<GetSchedule>('/api/scheduel/getSchedule', req);
}